import theme from "@/constants/theme";

const styles: Record<string, React.CSSProperties> = {
  contentContainer: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    gap: 16,
    paddingBottom: 16,
    paddingRight: 16,
    paddingLeft: 16,
    maxHeight: "100vh",
  },
  scrollContainer: {
    flexGrow: 1,
    maxHeight: "100%",
    display: "flex",
    flexDirection: "column",
    gap: 16,
    paddingBottom: 32,
  },
  title: {
    marginTop: 16,
    textAlign: "center",
    color: theme.colors.text.title,
  },
  aiResponseBox: {
    backgroundColor: "#0f1a3d",
    padding: 16,
    borderRadius: 8,
    marginTop: 24,
  },
  loadingContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  aiResponseText: {
    color: theme.colors.text.body,
    fontSize: 16,
    lineHeight: "1.4",
  },
  buttonsContainer: {
    display: "flex",
    justifyContent: "space-between",
    gap: 8,
  },
  backButton: {
    flex: 1,
    padding: "12px 16px",
    backgroundColor: "transparent",
    border: `1px solid ${theme.colors.primary}`,
    color: theme.colors.primary,
    borderRadius: 8,
    cursor: "pointer",
    fontWeight: "bold",
  },
  nextButton: {
    flex: 1,
    padding: "12px 16px",
    backgroundColor: theme.colors.primary,
    color: theme.colors.text.default,
    borderRadius: 8,
    cursor: "pointer",
    fontWeight: "bold",
    border: "none"
  },
  backButtonText: {
    textAlign: "center",
  },
  nextButtonText: {
    textAlign: "center",
  },
  section: {
    marginTop: 24,
    display: "flex",
    flexDirection: "column",
    gap: 8,
  },
  sectionLabel: {
    color: "#fff",
    fontSize: 16,
    fontWeight: "bold",
  },
  emotionContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: "#0f1a3d",
    padding: 12,
    borderRadius: 8,
  },
  emotionLabel: {
    color: "#fff",
    fontSize: 16,
    fontWeight: "bold",
  },
  emotionDescription: {
    color: "#ccc",
    fontSize: 14,
    marginTop: 4,
  },
  entryBox: {
    backgroundColor: "#0f1a3d",
    padding: 16,
    borderRadius: 8,
  },
  entryText: {
    color: theme.colors.text.body,
    fontSize: 15,
  },
};

export default styles;
